import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetServicingV1InstrumentsTokenTokenQuery, useGetServicingV1InstrumentsInstrumentIdFinalizeQuery, } from 'servicing-api';
import { setInstrumentId, setFinancialStatus, setLenderAccountIdentifier, } from '../actions';
import { selectors } from '../reducer';
function useFlexFinalizeData(authorizationToken) {
    const dispatch = useDispatch();
    const instrumentIdFromSelector = useSelector((state) => selectors.instrumentId(state));
    const lenderAccountIdentifierFromSelector = useSelector((state) => selectors.lenderAccountIdentifier(state));
    // Only fetch token if we don't yet have the instrument identity in Redux
    const shouldFetchToken = (!instrumentIdFromSelector || !lenderAccountIdentifierFromSelector) &&
        !!authorizationToken;
    const { data: tokenRes, isLoading: tokenIsLoading, isFetching: tokenIsFetching, } = useGetServicingV1InstrumentsTokenTokenQuery({ token: authorizationToken || '' }, { skip: !shouldFetchToken });
    // Use instrumentId from Redux or from the in-flight token response
    const instrumentId = instrumentIdFromSelector || (tokenRes?.id ? Number(tokenRes.id) : null);
    const { data: finalizeData, isLoading: finalizeIsLoading, isFetching: finalizeIsFetching, } = useGetServicingV1InstrumentsInstrumentIdFinalizeQuery({ instrumentId: instrumentId }, { skip: !instrumentId, refetchOnMountOrArgChange: true });
    // Store thin coordination state in Redux when the token resolves
    useEffect(() => {
        if (tokenRes &&
            (!instrumentIdFromSelector || !lenderAccountIdentifierFromSelector)) {
            dispatch(setInstrumentId(Number(tokenRes.id)));
            dispatch(setFinancialStatus(tokenRes.financialStatus));
            dispatch(setLenderAccountIdentifier(tokenRes.accountId));
        }
    }, [
        tokenRes,
        instrumentIdFromSelector,
        lenderAccountIdentifierFromSelector,
        dispatch,
    ]);
    const isLoading = (shouldFetchToken && (tokenIsLoading || tokenIsFetching)) ||
        (!!instrumentId && (finalizeIsLoading || finalizeIsFetching));
    // The lender account identifier (e.g. FLX-1234567) keys the account-scoped
    // bank account endpoints. It arrives with the same token response that
    // resolves the instrument, so it costs no extra request.
    const lenderAccountIdentifier = lenderAccountIdentifierFromSelector || tokenRes?.accountId || null;
    return {
        instrumentId,
        lenderAccountIdentifier,
        finalizeData: finalizeData ?? null,
        tokenRes: tokenRes || null,
        isLoading,
    };
}
export default useFlexFinalizeData;
